<template>
<div class="modal-card">
  
  <header class="modal-card-head">
    <p class="modal-card-title">This is how your book will be judged.</p>
  </header>
  
  <section class="modal-card-body">
    <div class="content">
      <b-field>
        <div class="control label">Colors</div>
        <div class="control">
          <swatches v-model="selections.coverBgColor"
                    :row-length="5" :colors="colors" @input="updateCover"
                    show-border popover-to="above">
            <a class="button" slot="trigger">
              <span class="color-sample" :style="'background-color: '+(selections.coverBgColor||'#333')+';'" >&nbsp;</span>
              <span>&nbsp;Cover</span>
              <b-icon icon="menu-down"></b-icon>
            </a>
          </swatches>
        </div>&nbsp;
        <swatches v-model="selections.coverTextColor"
                  :row-length="5" :colors="colors" @input="updateCover"
                  show-border>
          <a class="button" slot="trigger">
            <span class="color-sample" :style="'background-color: '+(selections.coverTextColor||'white')+';'">&nbsp;</span>
            <span>&nbsp;Text</span>
            <b-icon icon="menu-down"></b-icon>
          </a>
        </swatches>&nbsp;
        <a class="button" :style="'background-color: '+(selections.coverBgColor||'#333')+';'+ 
                                  'color: '+(selections.coverTextColor||'white')+';'">
          <strong>For Example</strong></a>
      </b-field>
      <b-field>
        <div class="control label">Title</div>
        <b-input v-model="selections.coverTitle"
                 placeholder="Title, also appears on the spine"
                 title="Title, also appears on the spine"
                 @input.native="updateCover" expanded></b-input>
      </b-field>
      <b-field>
        <div class="control label">Subtitle</div>
        <b-input v-model="selections.coverDescription"
                 placeholder="Subtitle - NOT on the spine"
                 title="Subtitle - NOT on the spine"
                 @input.native="updateCover" expanded></b-input>
      </b-field>
      <b-field>
        <div class="control label">Author</div>
        <b-input v-model="selections.coverAuthor"
                 placeholder="Author(s), also appears on the spine"
                 title="Author(s), also appears on the spine"
                 @input.native="updateCover" expanded></b-input>
      </b-field>
      <b-field>
        <div class="control label">Front Blurb</div>
        <b-input v-model="selections.coverBlurb1" type="textarea" rows="2"
                 placeholder="Some extra words to go on the front cover"
                 title="Some extra words to go on the front cover. You can use basic HTML formatting here"
                 @input.native="updateCover" expanded></b-input>
      </b-field>
      <b-field>
        <div class="control label">Title Page Blurb</div>
        <b-input v-model="selections.coverBlurb2" type="textarea" rows="2"
                 placeholder="A dedication or similar for the title page"
                 title="A dedication or similar for the title page. You can use basic HTML formatting here"
                 @input.native="updateCover" expanded></b-input>
      </b-field>
      <b-field>
        <div class="control label">Back Blurb</div>
        <b-input v-model="selections.coverBlurb3" type="textarea" rows="2"
                 placeholder="Some descriptive text for the back cover"
                 title="Some descriptive text for the back cover. You can use basic HTML formatting here"
                 @input.native="updateCover" expanded></b-input>
      </b-field>
    
      <div class="field" :class="{ 'drop-hover': fileDropFocussed }"
           @dragover.prevent="updateFileDropFocus(true)"
           @dragleave.prevent="updateFileDropFocus(false)"
           @dragenter.prevent="updateFileDropFocus(true)"
           @drop.prevent="onFileDropEvent">
        <b-field :type="fileDropFocussed ? 'is-success' : ''">
          <div class="control label">Image</div>
          <b-select v-model="imageMethod" @input.native="updateCover">
            <option value="mosaic6">Mosaic 6x6</option>
            <option value="mosaic8">Mosaic 8x8</option>
            <option value="mosaic">Mosaic All</option>
            <option value="none">None</option>
            <option value="link">Custom...</option>
          </b-select>
          <span v-if="imageMethod.startsWith('mosaic')" class="desc">&nbsp; will be automatically generated</span>
          <span v-else-if="imageMethod=='none'" class="desc">&nbsp; spartan minimalism</span>
          <b-input v-if="imageMethod=='link'"
                   :loading="imageFileProgress > 0 && imageFileProgress < 100"
                   v-model="selections.coverCustomImage"
                   placeholder="Enter URL or Drop File"
                   @input.native="updateCover" expanded></b-input>
          <b-upload v-if="imageMethod=='link'" class="button" 
                    v-model="imageFile" accept="image/*">
            <b-icon icon="upload"/></b-upload>
        </b-field>
        <b-field v-if="imageMethod=='link' && imageFile">
          <div class="control label"></div>
          <p v-if="imageFile.errmsg" class="errmsg">Ooops: {{imageFile.errmsg}}</p>
          <p v-else-if="imageFileProgress < 100" class="progmsg">Uploading: {{imageFileProgress}}%</p>
        </b-field>
      </div>

      <b-field>
        <div class="control label">Note to Self</div>
        <b-icon type="is-warning" icon="note"/>&nbsp;
        <b-input v-model="selections.noteToSelf"
                 placeholder="Identifying note, to tell one book from another. Not Printed!"
                 title="Identifying note, to tell one book from another. Not Printed!"
                 expanded></b-input>
      </b-field>
    </div>
    
  </section>

  <footer class="modal-card-foot">
    <div class="level">
      <div class="level-left"> </div>
      <div class="level-right">
        <button class="button" @click="cancel">Cancel</button>
        <button class="button is-primary" @click="done">Done</button>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.min.css"
  
import ActionLog from '../actionlog.js'
import Firebase from '../firebase.js'
var db = Firebase.database

var CoverColors = ['#000000', '#3A3A3A', '#666666', '#CCCCCC', '#FFFFFF', //b&w
                   '#50414C', '#5D3B42', '#A04344', '#E3493B', '#FF6600', //purple->red
                   '#726454', '#DDCDAE', '#DFD6CB', '#F7E29D', '#FFCC00', //browns
                   '#004040', '#87907D', '#C4C6A5', '#84B59C', '#427E83', //yellows->greens
                   '#336699', '#4086AA', '#91C3DC', '#A9DDD9', '#A1B8CA', //blues
                  ]
var others = ['#23B5AF', ]

export default {
  name: 'CoverConfigurator',
  components: {
    Swatches
  },
  data() { return {
    selections: {},
    colors: CoverColors, //'material-basic',
    somethingChanged: false,
    imageMethod: undefined,
    imageFile: undefined,
    imageFileProgress: 0,
    fileDropFocussed: false,
  } },
  props: {
    projid: { type: String, required: true },
    volid: { type: String, default: undefined },
  },
  methods: {
    updateCover: function() {
      console.log('cover changed!')
      this.somethingChanged = true;
    },
    cancel: function() {
      this.$parent.close()
    },
    done: function() {
      this.calcImageUrlFromMethod()
      var update = Object.assign({ configuredCover: true }, this.selections)
      delete update['.key']
      delete update['.value']
      console.log('selections', this.selections)
      console.log('update', update)
      this.$firebaseRefs.selections.update(update)
      if (this.somethingChanged) {
        ActionLog('preview_cover', {projid: this.projid})
        this.$emit('change')
      }
      this.$parent.close()
    },
    calcImageMethodFromUrl: function() {
      const url = this.selections.coverCustomImage
      if (!url) return 'mosaic' 
      else if (url.length < 6) {
        var dim = parseInt(url)
        if (isNaN(dim)) {
          return 'none'
        } else {
          return 'mosaic'+dim
        }
      }
      else return 'link'
    },
    calcImageUrlFromMethod: function() {
      if (this.imageMethod=='mosaic') {
        this.selections.coverCustomImage = ''
      } else if (this.imageMethod=='mosaic6') {
        this.selections.coverCustomImage = '6x6'
      } else if (this.imageMethod=='mosaic8') {
        this.selections.coverCustomImage = '8x8'
      } else if (this.imageMethod=='none') {
        this.selections.coverCustomImage = 'none'
      }
    },
    updateFileDropFocus: function(focus) {
      console.log('drag event', focus)
      this.fileDropFocussed = focus
    },
    onFileDropEvent: function(event) {
      this.imageMethod = 'link'
      this.updateFileDropFocus(false)
      const files = event.target.files || event.dataTransfer.files
      if (files && files.length && files.length >= 1) {
        this.imageFile = files[0]
      }
    },
    uploadFile: function() {
      var file = this.imageFile
      var ref = Firebase.storage.ref().child('customer').child(this.$store.state.uid).child(file.name)
      var task = ref.put(file)
      var self = this
      task.on('state_changed', function(snap) {
        var progress = parseInt((snap.bytesTransferred / snap.totalBytes) * 99)
        self.imageFileProgress = Math.max(self.imageFileProgress, progress)
        console.log('Upload is ' + progress + '% done');
      }, function(error) {
        console.log('Upload error ', error.code, error);
        const reason = error.code.split('/').length==2 ? error.code.split('/') : error.code
        file.errmsg = 'upload error ('+reason+')'
        self.imageFileProgress = 101
      }, function() {
        console.log('Upload success');
        task.snapshot.ref.getDownloadURL().then( function(url) {
          console.log('File at ', url);
          self.$set(self.selections, 'coverCustomImage', url)
          self.imageFileProgress = 100
          self.somethingChanged = true
        })
      })
    }
  },
  watch: {
    'imageFile': function(file) {
      console.log('uploading image file', file)
      if (file) {
        if (file.size > 5*1024*1024) {
          file.errmsg = 'max image size is 5MB'
        } else if (!file.type.startsWith('image/')) {
          file.errmsg = 'doesn\'t look like an image file'
        } else {
          this.imageFileProgress = 1
          this.uploadFile()
        }
      }
    },
  },
  beforeMount: function() {
    var path = "/projects/"+this.$store.state.uid+"/"+this.projid+"/selections"
    if (this.volid) { path += '/volumes/'+this.volid }
    var cover = db.ref(path)
    this.$bindAsObject("selections", cover, null,
      () => this.imageMethod = this.calcImageMethodFromUrl()
    )
  }
}
</script>

<style scoped>
span.desc {
  padding: 5px;
  font-style: italic;
  color: grey;
}
p.errmsg {
  color: red;
  font-style: italic;    
}
p.progmsg {
  color: green;
  font-style: italic;    
}
.level {
    width: 100%;
}
.modal-card-foot .button {
    min-width: 8em;
}
.field .control.label {
    min-width: 8em;
}
.color-sample {
    min-width: 2em;
    border: 1px solid black;
}

</style>



// WEBPACK FOOTER //
// src/components/CoverConfigurator.vue